/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface GooglerpcStatus {
  /** @format int32 */
  code?: number;
  message?: string;
  details?: ProtobufAny[];
}

export interface MinioEventList {
  items?: MinioResourceEvent[];
}

export interface MinioNode {
  name?: string;
  role?: string;
  version?: string;
  age?: string;
  taints?: string;
  pods?: string;
  status?: string;
}

export interface MinioNodeDescribe {
  /** NodeSpec describes the attributes that a node is created with. */
  nodeSpec?: V1NodeSpec;
  /** NodeStatus is information about the current status of a node. */
  nodeStatus?: V1NodeStatus;
  labels?: Record<string, string>;
  annotations?: Record<string, string>;
}

export interface MinioNodeList {
  nodes?: MinioNode[];
}

export interface MinioResourceEvent {
  namespace?: string;
  /** @format int64 */
  lastSeen?: string;
  eventType?: string;
  reason?: string;
  object?: string;
  message?: string;
}

export interface ProtobufAny {
  "@type"?: string;
  [key: string]: any;
}

/**
 * Quantity is a fixed-point representation of a number.
 * It provides convenient marshaling/unmarshaling in JSON and YAML,
 * in addition to String() and AsInt64() accessors.
 *
 * The serialization format is:
 *
 * ```
 * <quantity>        ::= <signedNumber><suffix>
 *
 * 	(Note that <suffix> may be empty, from the "" case in <decimalSI>.)
 *
 * <digit>           ::= 0 | 1 | ... | 9
 * <digits>          ::= <digit> | <digit><digits>
 * <number>          ::= <digits> | <digits>.<digits> | <digits>. | .<digits>
 * <sign>            ::= "+" | "-"
 * <signedNumber>    ::= <number> | <sign><number>
 * <suffix>          ::= <binarySI> | <decimalExponent> | <decimalSI>
 * <binarySI>        ::= Ki | Mi | Gi | Ti | Pi | Ei
 *
 * 	(International System of units; See: http://physics.nist.gov/cuu/Units/binary.html)
 *
 * <decimalSI>       ::= m | "" | k | M | G | T | P | E
 *
 * 	(Note that 1024 = 1Ki but 1000 = 1k; I didn't choose the capitalization.)
 *
 * <decimalExponent> ::= "e" <signedNumber> | "E" <signedNumber>
 * ```
 *
 * No matter which of the three exponent forms is used, no quantity may represent
 * a number greater than 2^63-1 in magnitude, nor may it have more than 3 decimal
 * places. Numbers larger or more precise will be capped or rounded up.
 * (E.g.: 0.1m will rounded up to 1m.)
 * This may be extended in the future if we require larger or smaller quantities.
 *
 * When a Quantity is parsed from a string, it will remember the type of suffix
 * it had, and will use the same type again when it is serialized.
 *
 * Before serializing, Quantity will be put in "canonical form".
 * This means that Exponent/suffix will be adjusted up or down (with a
 * corresponding increase or decrease in Mantissa) such that:
 *
 * - No precision is lost
 * - No fractional digits will be emitted
 * - The exponent (or suffix) is as large as possible.
 *
 * The sign will be omitted unless the number is negative.
 *
 * Examples:
 *
 * - 1.5 will be serialized as "1500m"
 * - 1.5Gi will be serialized as "1536Mi"
 *
 * Note that the quantity will NEVER be internally represented by a
 * floating point number. That is the whole point of this exercise.
 *
 * Non-canonical values will still parse as long as they are well formed,
 * but will be re-emitted in their canonical form. (So always use canonical
 * form, or don't diff.)
 *
 * This format is intended to make it difficult to use these numbers without
 * writing some sort of special handling code in the hopes that that will
 * cause implementors to also use a fixed point implementation.
 *
 * +protobuf=true
 * +protobuf.embed=string
 * +protobuf.options.marshal=false
 * +protobuf.options.(gogoproto.goproto_stringer)=false
 * +k8s:deepcopy-gen=true
 * +k8s:openapi-gen=true
 */
export interface ResourceQuantity {
  string?: string;
}

/** AttachedVolume describes a volume attached to a node */
export interface V1AttachedVolume {
  /** Name of the attached volume */
  name?: string;
  /** DevicePath represents the device path where the volume should be available */
  devicePath?: string;
}

/**
 * ConfigMapNodeConfigSource contains the information to reference a ConfigMap as a config source for the Node.
 * This API is deprecated since 1.22: https://git.k8s.io/enhancements/keps/sig-node/281-dynamic-kubelet-configuration
 */
export interface V1ConfigMapNodeConfigSource {
  /**
   * Namespace is the metadata.namespace of the referenced ConfigMap.
   * This field is required in all cases.
   */
  namespace?: string;
  /**
   * Name is the metadata.name of the referenced ConfigMap.
   * This field is required in all cases.
   */
  name?: string;
  /**
   * UID is the metadata.UID of the referenced ConfigMap.
   * This field is forbidden in Node.Spec, and required in Node.Status.
   * +optional
   */
  uid?: string;
  /**
   * ResourceVersion is the metadata.ResourceVersion of the referenced ConfigMap.
   * This field is forbidden in Node.Spec, and required in Node.Status.
   * +optional
   */
  resourceVersion?: string;
  /**
   * KubeletConfigKey declares which key of the referenced ConfigMap corresponds to the KubeletConfiguration structure
   * This field is required in all cases.
   */
  kubeletConfigKey?: string;
}

/** Describe a container image */
export interface V1ContainerImage {
  /**
   * Names by which this image is known.
   * e.g. ["kubernetes.example/hyperkube:v1.0.7", "cloud-vendor.registry.example/cloud-vendor/hyperkube:v1.0.7"]
   * +optional
   * +listType=atomic
   */
  names?: string[];
  /**
   * The size of the image in bytes.
   * +optional
   * @format int64
   */
  sizeBytes?: string;
}

/** DaemonEndpoint contains information about a single Daemon endpoint. */
export interface V1DaemonEndpoint {
  /**
   * Port number of the given endpoint.
   * @format int32
   */
  Port?: number;
}

/** NodeAddress contains information for the node's address. */
export interface V1NodeAddress {
  /** Node address type, one of Hostname, ExternalIP or InternalIP. */
  type?: string;
  /** The node address. */
  address?: string;
}

/** NodeCondition contains condition information for a node. */
export interface V1NodeCondition {
  /** Type of node condition. */
  type?: string;
  /** Status of the condition, one of True, False, Unknown. */
  status?: string;
  /**
   * Last time we got an update on a given condition.
   * +optional
   * Time is a wrapper around time.Time which supports correct
   * marshaling to YAML and JSON.  Wrappers are provided for many
   * of the factory methods that the time package offers.
   *
   * +protobuf.options.marshal=false
   * +protobuf.as=Timestamp
   * +protobuf.options.(gogoproto.goproto_stringer)=false
   */
  lastHeartbeatTime?: V1Time;
  /**
   * Last time the condition transit from one status to another.
   * +optional
   * Time is a wrapper around time.Time which supports correct
   * marshaling to YAML and JSON.  Wrappers are provided for many
   * of the factory methods that the time package offers.
   *
   * +protobuf.options.marshal=false
   * +protobuf.as=Timestamp
   * +protobuf.options.(gogoproto.goproto_stringer)=false
   */
  lastTransitionTime?: V1Time;
  /**
   * (brief) reason for the condition's last transition.
   * +optional
   */
  reason?: string;
  /**
   * Human readable message indicating details about last transition.
   * +optional
   */
  message?: string;
}

/**
 * NodeConfigSource specifies a source of node configuration. Exactly one subfield (excluding metadata) must be non-nil.
 * This API is deprecated since 1.22
 */
export interface V1NodeConfigSource {
  /** ConfigMap is a reference to a Node's ConfigMap */
  configMap?: V1ConfigMapNodeConfigSource;
}

/** NodeConfigStatus describes the status of the config assigned by Node.Spec.ConfigSource. */
export interface V1NodeConfigStatus {
  /**
   * Assigned reports the checkpointed config the node will try to use.
   * When Node.Spec.ConfigSource is updated, the node checkpoints the associated
   * config payload to local disk, along with a record indicating intended
   * config. The node refers to this record to choose its config checkpoint, and
   * reports this record in Assigned. Assigned only updates in the status after
   * the record has been checkpointed to disk. When the Kubelet is restarted,
   * it tries to make the Assigned config the Active config by loading and
   * validating the checkpointed payload identified by Assigned.
   * +optional
   */
  assigned?: V1NodeConfigSource;
  /**
   * Active reports the checkpointed config the node is actively using.
   * Active will represent either the current version of the Assigned config,
   * or the current LastKnownGood config, depending on whether attempting to use the
   * Assigned config results in an error.
   * +optional
   */
  active?: V1NodeConfigSource;
  /**
   * LastKnownGood reports the checkpointed config the node will fall back to
   * when it encounters an error attempting to use the Assigned config.
   * The Assigned config becomes the LastKnownGood config when the node determines
   * that the Assigned config is stable and correct.
   * This is currently implemented as a 10-minute soak period starting when the local
   * record of Assigned config is updated. If the Assigned config is Active at the end
   * of this period, it becomes the LastKnownGood. Note that if Spec.ConfigSource is
   * reset to nil (use local defaults), the LastKnownGood is also immediately reset to nil,
   * because the local default config is always assumed good.
   * You should not make assumptions about the node's method of determining config stability
   * and correctness, as this may change or become configurable in the future.
   * +optional
   */
  lastKnownGood?: V1NodeConfigSource;
  /**
   * Error describes any problems reconciling the Spec.ConfigSource to the Active config.
   * Errors may occur, for example, attempting to checkpoint Spec.ConfigSource to the local Assigned
   * record, attempting to checkpoint the payload associated with Spec.ConfigSource, attempting
   * to load or validate the Assigned config, etc.
   * Errors may occur at different points while syncing config. Earlier errors (e.g. download or
   * checkpointing errors) will not result in a rollback to LastKnownGood, and may resolve across
   * Kubelet retries. Later errors (e.g. loading or validating a checkpointed config) will result in
   * a rollback to LastKnownGood. In the latter case, it is usually possible to resolve the error
   * by fixing the config assigned in Spec.ConfigSource.
   * You can find additional information for debugging by searching the error message in the Kubelet log.
   * Error is a human-readable description of the error state; machines can check whether or not Error
   * is empty, but should not rely on the stability of the Error text across Kubelet versions.
   * +optional
   */
  error?: string;
}

/** NodeDaemonEndpoints lists ports opened by daemons running on the Node. */
export interface V1NodeDaemonEndpoints {
  /**
   * Endpoint on which Kubelet is listening.
   * +optional
   * DaemonEndpoint contains information about a single Daemon endpoint.
   */
  kubeletEndpoint?: V1DaemonEndpoint;
}

/** NodeSpec describes the attributes that a node is created with. */
export interface V1NodeSpec {
  /**
   * PodCIDR represents the pod IP range assigned to the node.
   * +optional
   */
  podCIDR?: string;
  /**
   * podCIDRs represents the IP ranges assigned to the node for usage by Pods on that node. If this
   * field is specified, the 0th entry must match the podCIDR field. It may contain at most 1 value for
   * each of IPv4 and IPv6.
   * +optional
   * +patchStrategy=merge
   * +listType=set
   */
  podCIDRs?: string[];
  /**
   * ID of the node assigned by the cloud provider in the format: <ProviderName>://<ProviderSpecificNodeID>
   * +optional
   */
  providerID?: string;
  /**
   * Unschedulable controls node schedulability of new pods. By default, node is schedulable.
   * More info: https://kubernetes.io/docs/concepts/nodes/node/#manual-node-administration
   * +optional
   */
  unschedulable?: boolean;
  /**
   * If specified, the node's taints.
   * +optional
   * +listType=atomic
   */
  taints?: V1Taint[];
  /**
   * Deprecated: Previously used to specify the source of the node's configuration for the DynamicKubeletConfig feature. This feature is removed.
   * +optional
   */
  configSource?: V1NodeConfigSource;
  /**
   * Deprecated. Not all kubelets will set this field. Remove field after 1.13.
   * see: https://issues.k8s.io/61966
   * +optional
   */
  externalID?: string;
}

/** NodeStatus is information about the current status of a node. */
export interface V1NodeStatus {
  /**
   * Capacity represents the total resources of a node.
   * More info: https://kubernetes.io/docs/concepts/storage/persistent-volumes#capacity
   * +optional
   */
  capacity?: Record<string, ResourceQuantity>;
  /**
   * Allocatable represents the resources of a node that are available for scheduling.
   * Defaults to Capacity.
   * +optional
   */
  allocatable?: Record<string, ResourceQuantity>;
  /**
   * NodePhase is the recently observed lifecycle phase of the node.
   * More info: https://kubernetes.io/docs/concepts/nodes/node/#phase
   * The field is never populated, and now is deprecated.
   * +optional
   */
  phase?: string;
  /**
   * Conditions is an array of current observed node conditions.
   * More info: https://kubernetes.io/docs/concepts/nodes/node/#condition
   * +optional
   * +patchMergeKey=type
   * +patchStrategy=merge
   * +listType=map
   * +listMapKey=type
   */
  conditions?: V1NodeCondition[];
  /**
   * List of addresses reachable to the node.
   * Queried from cloud provider, if available.
   * More info: https://kubernetes.io/docs/concepts/nodes/node/#addresses
   * Note: This field is declared as mergeable, but the merge key is not sufficiently
   * unique, which can cause data corruption when it is merged. Callers should instead
   * use a full-replacement patch. See https://pr.k8s.io/79391 for an example.
   * Consumers should assume that addresses can change during the
   * lifetime of a Node. However, there are some exceptions where this may not
   * be possible, such as Pods that inherit a Node's address in its own status or
   * consumers of the downward API (status.hostIP).
   * +optional
   * +patchMergeKey=type
   * +patchStrategy=merge
   * +listType=map
   * +listMapKey=type
   */
  addresses?: V1NodeAddress[];
  /**
   * Endpoints of daemons running on the Node.
   * +optional
   * NodeDaemonEndpoints lists ports opened by daemons running on the Node.
   */
  daemonEndpoints?: V1NodeDaemonEndpoints;
  /**
   * Set of ids/uuids to uniquely identify the node.
   * More info: https://kubernetes.io/docs/concepts/nodes/node/#info
   * +optional
   * NodeSystemInfo is a set of ids/uuids to uniquely identify the node.
   */
  nodeInfo?: V1NodeSystemInfo;
  /**
   * List of container images on this node
   * +optional
   * +listType=atomic
   */
  images?: V1ContainerImage[];
  /**
   * List of attachable volumes in use (mounted) by the node.
   * +optional
   * +listType=atomic
   */
  volumesInUse?: string[];
  /**
   * List of volumes that are attached to the node.
   * +optional
   * +listType=atomic
   */
  volumesAttached?: V1AttachedVolume[];
  /**
   * Status of the config assigned to the node via the dynamic Kubelet config feature.
   * +optional
   * NodeConfigStatus describes the status of the config assigned by Node.Spec.ConfigSource.
   */
  config?: V1NodeConfigStatus;
}

/** NodeSystemInfo is a set of ids/uuids to uniquely identify the node. */
export interface V1NodeSystemInfo {
  /**
   * MachineID reported by the node. For unique machine identification
   * in the cluster this field is preferred. Learn more from man(5)
   * machine-id: http://man7.org/linux/man-pages/man5/machine-id.5.html
   */
  machineID?: string;
  /**
   * SystemUUID reported by the node. For unique machine identification
   * MachineID is preferred. This field is specific to Red Hat hosts
   * https://access.redhat.com/documentation/en-us/red_hat_subscription_management/1/html/rhsm/uuid
   */
  systemUUID?: string;
  /** Boot ID reported by the node. */
  bootID?: string;
  /** Kernel Version reported by the node from 'uname -r' (e.g. 3.16.0-0.bpo.4-amd64). */
  kernelVersion?: string;
  /** OS Image reported by the node from /etc/os-release (e.g. Debian GNU/Linux 7 (wheezy)). */
  osImage?: string;
  /** ContainerRuntime Version reported by the node through runtime remote API (e.g. containerd://1.4.2). */
  containerRuntimeVersion?: string;
  /** Kubelet Version reported by the node. */
  kubeletVersion?: string;
  /** KubeProxy Version reported by the node. */
  kubeProxyVersion?: string;
  /** The Operating System reported by the node */
  operatingSystem?: string;
  /** The Architecture reported by the node */
  architecture?: string;
}

/**
 * The node this Taint is attached to has the "effect" on
 * any pod that does not tolerate the Taint.
 */
export interface V1Taint {
  /** Required. The taint key to be applied to a node. */
  key?: string;
  /**
   * The taint value corresponding to the taint key.
   * +optional
   */
  value?: string;
  /**
   * Required. The effect of the taint on pods
   * that do not tolerate the taint.
   * Valid effects are NoSchedule, PreferNoSchedule and NoExecute.
   */
  effect?: string;
  /**
   * TimeAdded represents the time at which the taint was added.
   * It is only written for NoExecute taints.
   * +optional
   * Time is a wrapper around time.Time which supports correct
   * marshaling to YAML and JSON.  Wrappers are provided for many
   * of the factory methods that the time package offers.
   *
   * +protobuf.options.marshal=false
   * +protobuf.as=Timestamp
   * +protobuf.options.(gogoproto.goproto_stringer)=false
   */
  timeAdded?: V1Time;
}

/**
 * Time is a wrapper around time.Time which supports correct
 * marshaling to YAML and JSON.  Wrappers are provided for many
 * of the factory methods that the time package offers.
 *
 * +protobuf.options.marshal=false
 * +protobuf.as=Timestamp
 * +protobuf.options.(gogoproto.goproto_stringer)=false
 */
export interface V1Time {
  /**
   * Represents seconds of UTC time since Unix epoch
   * 1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to
   * 9999-12-31T23:59:59Z inclusive.
   * @format int64
   */
  seconds?: string;
  /**
   * Non-negative fractions of a second at nanosecond resolution. Negative
   * second values with fractions must still have non-negative nanos values
   * that count forward in time. Must be from 0 to 999,999,999
   * inclusive. This field may be limited in precision depending on context.
   * @format int32
   */
  nanos?: number;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title nodes.proto
 * @version version not set
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags NodesRpcs
     * @name GetNodeList
     * @request GET:/api/v2/sites/{siteID}/namespaces/{namespace}/nodes
     */
    getNodeList: (
      siteId: string,
      namespace: string,
      query?: {
        resourceID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MinioNodeList, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/nodes`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags NodesRpcs
     * @name GetNodeDescribe
     * @request GET:/api/v2/sites/{siteID}/namespaces/{namespace}/nodes/{resourceID}/describe
     */
    getNodeDescribe: (
      siteId: string,
      namespace: string,
      resourceId: string,
      params: RequestParams = {},
    ) =>
      this.request<MinioNodeDescribe, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/nodes/${resourceId}/describe`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags NodesRpcs
     * @name GetNodeEvents
     * @request GET:/api/v2/sites/{siteID}/namespaces/{namespace}/nodes/{resourceID}/events
     */
    getNodeEvents: (
      siteId: string,
      namespace: string,
      resourceId: string,
      params: RequestParams = {},
    ) =>
      this.request<MinioEventList, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/nodes/${resourceId}/events`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
}
